import React from 'react';
import { createRoot } from 'react-dom/client';
import '@fontsource-variable/inter';
import '@fontsource-variable/nunito';
import './styles/tokens.css';
import './styles/base.css';
import './styles/components.css';
import './styles/screens.css';
import { App } from './App.js';
import { ErrorBoundary } from './ErrorBoundary.js';
import { reportClientError } from './lib/api.js';

// журнал ошибок лида: всё, что упало мимо обработчиков, — на сервер с id лида
window.addEventListener('error', (event) => {
  reportClientError({
    kind: 'error',
    message: event.message || String(event.error),
    ...(event.error instanceof Error && event.error.stack ? { stack: event.error.stack } : {}),
  });
});
window.addEventListener('unhandledrejection', (event) => {
  const reason: unknown = event.reason;
  reportClientError({
    kind: 'unhandled',
    message: reason instanceof Error ? reason.message : String(reason),
    ...(reason instanceof Error && reason.stack ? { stack: reason.stack } : {}),
  });
});

const container = document.getElementById('root');
if (!container) throw new Error('#root not found');

createRoot(container).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);
